import styled from 'styled-components';
import classNames from 'classnames';
import { renderStyledElementStyles } from '../../../../helpers';

export const StyledIcon = styled.i`
  color: inherit;

  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.icon)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.icon)}
`;

export type IconProps = {
  matIcon: string;
  outlined?: boolean;
};

export const Icon = ({ matIcon, outlined }: IconProps) => {
  return (
    <StyledIcon
      className={classNames({
        'material-icons': !outlined,
        'material-icons-outlined': outlined,
      })}
    >
      {matIcon}
    </StyledIcon>
  );
};
